import React from "react";
import { Link } from "react-router-dom";

// Components
import Button from "../../Button/Button";
import { ProgressiveImage } from "../../ProgressiveImage/ProgressiveImage";

// Utils
import { cn } from "../../../utils";

// Icons
import ArrowRightIcon from "../../../icons/ArrowRightIcon";
import CheckNiceIcon from "../../../icons/CheckNiceIcon";

export const EventSeriesSlide = ({
  item: seriesData,
  to,
  imgClassName,
  showRsvpCta,
  hideRsvp,
  onRsvpCtaClick,
}) => {
  return to || showRsvpCta ? (
    <Link
      to={to || `/events/series/${seriesData.id}`}
      className="tbk-mb-2 lg:tbk-mb-0"
      onClick={onRsvpCtaClick}
    >
      <div className="tbk-relative">
        <div className="tbk-absolute tbk-right-3 tbk-top-0 tbk-hidden tbk-text-right">
          {seriesData.capacity === seriesData.currentCapacity ? (
            <div className="tbk-text-main tbk-rounded-b-lg tbk-bg-primary tbk-px-1 tbk-text-basic-white">
              Sold Out
            </div>
          ) : null}
          {seriesData.joined && (
            <CheckNiceIcon
              width={24}
              height={24}
              className="tbk-mt-3 tbk-inline-block tbk-rounded-full tbk-border tbk-border-basic-white tbk-bg-green tbk-text-basic-white"
            />
          )}
        </div>
        <ProgressiveImage
          className={cn(
            "tbk-relative tbk-mb-2 tbk-w-full tbk-overflow-hidden tbk-rounded-2xl tbk-object-cover tbk-object-left-top",
            imgClassName
          )}
          src={seriesData.coverPhoto}
          //srcSet={`${access2xImg} 2x, ${access3xImg} 3x`}
          imgConfig={[]}
          alt="Upcoming Fitness and wellbeing classes"
          logoHeight={56}
          imgStyle={{
            width: "100%",
            height: "100%",
          }}
        />
        {showRsvpCta && !hideRsvp ? (
          <Button
            variant="secondary"
            size="md"
            className="tbk-w-full"
            endIcon={<ArrowRightIcon />}
          >
            View
          </Button>
        ) : null}
      </div>
    </Link>
  ) : (
    <div className="tbk-relative">
      <div className="tbk-absolute tbk-right-3 tbk-top-0 tbk-text-right">
        {seriesData.capacity === seriesData.currentCapacity ? (
          <div className="tbk-text-main tbk-rounded-b-lg tbk-bg-primary tbk-px-1 tbk-text-basic-white">
            Sold Out
          </div>
        ) : null}
        {seriesData.joined && (
          <CheckNiceIcon
            width={24}
            height={24}
            className="tbk-mt-3 tbk-inline-block tbk-rounded-full tbk-border tbk-border-basic-white tbk-bg-green tbk-text-basic-white"
          />
        )}
      </div>
      <img
        className={`${
          imgClassName ? `${imgClassName} ` : ""
        }tbk-mb-2 tbk-w-full tbk-overflow-hidden tbk-rounded-2xl tbk-object-cover tbk-object-left-top`}
        src={seriesData.coverPhoto}
        alt="Series of Classes"
      />
      {showRsvpCta ? (
        <Button
          variant="secondary"
          size="md"
          className="tbk-w-full"
          endIcon={<ArrowRightIcon />}
        >
          View
        </Button>
      ) : null}
    </div>
  );
};
